const getEnv = () => {
	const prodEnvironments = ['https://catalog.brighthr.com', 'https://catalog-web.pages.dev'];
	return prodEnvironments.includes(window.location.origin) ? 'prod' : 'sand';
};

export default getEnv;
